import { render, staticRenderFns } from "./BusinessForm.vue?vue&type=template&id=5811a1e9&scoped=true"
import script from "./BusinessForm.vue?vue&type=script&lang=js"
export * from "./BusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811a1e9",
  null
  
)

export default component.exports